// extracted by mini-css-extract-plugin
export var copy = "style-module--copy--oFWBm";
export var copy__main = "style-module--copy__main--HYV9Q";
export var copy__sub = "style-module--copy__sub--6qb5c";
export var mainVisual = "style-module--mainVisual--COQAg";
export var pathMove = "style-module--pathMove--pKKKb";
export var scrollDown = "style-module--scrollDown--KilPF";